// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#company-information {
    width: 100%;
    background-color: #282828;
    color: #f0f0f0;
    padding: 5rem 0;
}

.company-info-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    width: 80%;
    margin: 0 auto;
}

.company-info-section {
    width: 100%;
    margin: 2rem 0;
}

.info-title {
    height: 8rem;
    background-color: #7a7ab6;
    color: #ffffff;
    border-radius: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.info-body {
    text-align: center;
    margin-top: 2rem;
    font-size: 14px;
}

.location-info {
    display: flex;
    justify-content: space-around;
}

.location-block {
    height: fit-content;
}

.location-block:first-child {
    margin-bottom: 1rem
}
.location-block h3:first-child {
    margin-top: 0;
    margin-bottom: 0;
    font-size: 24px;
    color: #7a7ab6;
}

.info-body-links {
    text-decoration: none;
    display: block; 
    margin: 1rem 0;
    color: inherit;
    font-weight: 700;
    font-size: 16px
}

.info-body-links:hover {
    color: #4545C4;
}

.contact-info {
    word-wrap: break-word;
}

@media screen and (min-width: 768px) {
    .company-info-container {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-around;
        width: 80%;
        margin: 0 auto;
    }

    .company-info-section {
        width: 30%;
        margin: 0;
    }

    .info-title {
        height: 10rem;
    }
}`, "",{"version":3,"sources":["webpack://./components/CompanyInfoContainer/CompanyInfoContainer.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,6BAA6B;IAC7B,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;AACJ;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,aAAa;QACb,iBAAiB;QACjB,6BAA6B;QAC7B,UAAU;QACV,cAAc;IAClB;;IAEA;QACI,UAAU;QACV,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":["#company-information {\n    width: 100%;\n    background-color: #282828;\n    color: #f0f0f0;\n    padding: 5rem 0;\n}\n\n.company-info-container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-around;\n    width: 80%;\n    margin: 0 auto;\n}\n\n.company-info-section {\n    width: 100%;\n    margin: 2rem 0;\n}\n\n.info-title {\n    height: 8rem;\n    background-color: #7a7ab6;\n    color: #ffffff;\n    border-radius: 1rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.info-body {\n    text-align: center;\n    margin-top: 2rem;\n    font-size: 14px;\n}\n\n.location-info {\n    display: flex;\n    justify-content: space-around;\n}\n\n.location-block {\n    height: fit-content;\n}\n\n.location-block:first-child {\n    margin-bottom: 1rem\n}\n.location-block h3:first-child {\n    margin-top: 0;\n    margin-bottom: 0;\n    font-size: 24px;\n    color: #7a7ab6;\n}\n\n.info-body-links {\n    text-decoration: none;\n    display: block; \n    margin: 1rem 0;\n    color: inherit;\n    font-weight: 700;\n    font-size: 16px\n}\n\n.info-body-links:hover {\n    color: #4545C4;\n}\n\n.contact-info {\n    word-wrap: break-word;\n}\n\n@media screen and (min-width: 768px) {\n    .company-info-container {\n        display: flex;\n        flex-wrap: nowrap;\n        justify-content: space-around;\n        width: 80%;\n        margin: 0 auto;\n    }\n\n    .company-info-section {\n        width: 30%;\n        margin: 0;\n    }\n\n    .info-title {\n        height: 10rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
